import React, { useState, useContext, useEffect, useRef } from "react";
import "./image.css"

import { ClipLoader } from "react-spinners";


function Image(props) {
    const [loading, setLoading] = useState(true)
    const [img, setImg] = useState(props.src)
    const count = useRef(0)
    useEffect(()=>{
        // console.log(img)
        if (count.current>0) {
            setLoading(!loading)
            setImg(props.src)
        }
        else {
            count.current+=1
        }
        // setLoading(true)

        // console.log("props.src", props.src)
    }, [props.src])

    useEffect(()=>{
        // if (props.src.includes("MINSLMBUN")) {
        //     console.log("count", count, "loading", loading, "src", props.src)
        // }
        // console.log("loading", loading, "src", props.src)
    }, [loading])


    return(
        <>
        {
            loading?
            <ClipLoader
                className="img-loader"
                color={"#4b51f0"}
                loading={loading}
                size={props.spinnerSize?props.spinnerSize:100}
            />:""
            
        }
        <img className="image" style={{display:`${loading?"none":"initial"}`}} onLoad={()=>setLoading(false)} src={img} width={props.width?props.width:"100%"} height={props.height?props.height:"auto"} alt="" />
        </>
    )
}

export default Image